export default "__VITE_ASSET__DweLKFyR__"